import React, { useState, useEffect } from 'react';
import Header from './Header.jsx';
import Footer from './Footer.jsx';
import banner from '../assets/banners/img2.avif';
import { FiTrendingUp, FiAward, FiSettings, FiGlobe, FiShield, FiCheckCircle, FiUsers, FiZap, FiTarget } from 'react-icons/fi';
import { FaRegBuilding } from 'react-icons/fa';
import { AiOutlineStar } from 'react-icons/ai';
import VisionMission from './VisionMission.jsx';
import '../css/aboutus.css';
import p1 from '../assets/growth/forged2.PNG';
import p2 from '../assets/growth/gate_valves.jpeg';
import p3 from '../assets/growth/globe_valves.jpeg';
import p4 from '../assets/growth/swing_check_valve.jpeg';
import p5 from '../assets/growth/dualplatecheck_valves.jpeg';
import p6 from '../assets/growth/floatingball_valves.jpeg';
import p7 from '../assets/growth/trunnionmountedall_valves.jpeg';
import p8 from '../assets/growth/butterfly_valves.jpeg';

const verticalTimeline = [
  { icon: <FiTrendingUp className="v-timeline-icon" />, year: '2017', title: 'Founded Anu Valves', desc: 'Founded Anu Valves in the year 2017 which is based in Ahmedabad, Gujarat and was working as partner.' },
  { icon: <FiGlobe className="v-timeline-icon" />, year: '2021', title: 'Separated from Anu Valves', desc: 'Separated from Anu Valves' },
  { icon: <FaRegBuilding className="v-timeline-icon" />, year: '2022', title: 'Founded Anu Flow Controls', desc: 'Founded Anu Flow Controls in the year 2022 which is based in Hubli' },
  { icon: <FiSettings className="v-timeline-icon" />, year: '2023', title: 'Manufacturing Expansion', desc: 'Started Manufacturing Gate Valve, Globe Valve and Swing check Valves up to 24" in Class 1500' },
  { icon: <FiAward className="v-timeline-icon" />, year: '2024', title: 'Trunnion Mounted Ball Valves', desc: 'Started Manufacturing Trunnion Mounted Ball Valves up to 12" in class 600' },
  { icon: <FiZap className="v-timeline-icon" />, year: '2025', title: 'Forged Steel Valves', desc: 'Started Manufacturing Forged Steel Valves with full capacity' }
];

function VerticalTimelineSection() {
  return (
    <section className="vertical-timeline-section">
      <div className="v-timeline-header">
        <h3 className="v-timeline-title">Our Growth Journey</h3>
        <div className="v-divider"></div>
        <p className="v-timeline-subtitle">Precision, innovation, and trust—major milestones that shaped our company.</p>
      </div>
      <div className="vertical-timeline-bar-wrap">
        <div className="vertical-timeline-bar">
          {verticalTimeline.map((n, i) => (
            <div className="vertical-timeline-node fade-slide-in" key={n.year}>
              <div className="v-timeline-node-circle">{n.icon}</div>
              <div className="vertical-timeline-info">
                <div className="v-timeline-year">{n.year}</div>
                <div className="v-timeline-m-title">{n.title}</div>
                <div className="v-timeline-m-desc">{n.desc}</div>
              </div>
              <span className="v-timeline-connector"></span>
            </div>
          ))}
        </div>
      </div>
      <div className="timeline-trust-bar">
        <div className="timeline-stars">
          {Array(5).fill().map((_,i) => (
            <AiOutlineStar key={i} className="timeline-star-animated" />
          ))}
        </div>
        <div className="timeline-bullets">
          <span>ISO 9001:2015, ASME, API certified</span>
          <span>Integrated manufacturing/testing</span>
          <span>1-acre expansion for global scale</span>
          <span>Valves trusted worldwide</span>
        </div>
      </div>
    </section>
  );
}

const coreValues = [
  { icon: <FiShield className="cv-bubble-icon" />, title: 'Integrity', desc: 'We build lasting trust through transparency, ethics, and accountability.' },
  { icon: <FiCheckCircle className="cv-bubble-icon" />, title: 'Quality First', desc: 'Relentless attention to standards, testing, and precision engineering.' },
  { icon: <FiZap className="cv-bubble-icon" />, title: 'Innovation', desc: 'Continuous improvement and modern manufacturing practices.' },
  { icon: <FiUsers className="cv-bubble-icon" />, title: 'Customer Focus', desc: 'Reliable delivery, responsive support, and partnership mindset.' }
];

function CoreValuesSection() {
  return (
    <section className="core-values">
      <div className="cv-header">
       
        <h3 className="cv-title">Our Core Values</h3>
        <div className="cv-divider"></div>
        <p className="cv-subtitle">The principles that power our people, our products, and our promise.</p>
      </div>
      <div className="cv-list">
        {coreValues.map((v, idx) => (
          <div className="cv-item" key={v.title} style={{ animationDelay: `${idx * 120}ms` }}>
            <div className="cv-bubble">{v.icon}</div>
            <div className="cv-text">
              <h4 className="cv-item-title">{v.title}</h4>
              <p className="cv-item-desc">{v.desc}</p>
            </div>
            <span className="cv-line" />
          </div>
        ))}
      </div>
    </section>
  );
}

const valveItems = [
  { name: 'Forged Valves', img: p1 },
  { name: 'Gate Valves', img: p2 },
  { name: 'Globe Valves', img: p3 },
  { name: 'Swing Check Valves', img: p4 },
  { name: 'Dual Plate Check Valves', img: p5 },
  { name: 'Floating Ball Valves', img: p6 },
  { name: 'Trunnion Mounted Ball Valves', img: p7 },
  { name: 'Butterfly Valves', img: p8 }
];

function ValveShowcase() {
  const [active, setActive] = useState(0);
  return (
    <section className="valve-showcase">
      <div className="valve-wrap">
        <div className="valve-left">
          <div className="valve-title">Explore Our Valve Range</div>
          <ul className="valve-list" role="list">
            {valveItems.map((v, i) => (
              <li
                key={v.name}
                className={`valve-item ${active === i ? 'active' : ''}`}
                onMouseEnter={() => setActive(i)}
                onFocus={() => setActive(i)}
                tabIndex={0}
              >
                <span className="valve-dot" />
                <span className="valve-name">{v.name}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="valve-right">
          {valveItems.map((v, i) => (
            <img
              key={v.name}
              src={v.img}
              alt={v.name}
              className={`valve-img ${active === i ? 'show' : ''}`}
            />
          ))}
          <div className="valve-img-overlay" />
        </div>
      </div>
    </section>
  );
}

const sustainabilityContent = [
  {
    icon: <FiTarget className="sust-icon" />,
    title: 'Sense of Purpose',
    desc: 'Our business is always driven by a sense of purpose, establishing a method that is suitable for Anu Flow Controls\' management, production, sales, and service. We work hard to transform and restructure our products while setting up a model of sustainable development that ensures long-term growth and responsibility.'
  },
  {
    icon: <FiTrendingUp className="sust-icon" />,
    title: 'Sustainability Targets',
    desc: 'We are growing our business by building on our strengths — combining our scale and expertise with our understanding of customers in diverse markets to continue providing brands and services that meet evolving market demands and requirements. Our sustainable business model is making a difference to both the development of industry and our environmental impact.'
  },
  {
    icon: <FiZap className="sust-icon" />,
    title: 'Corporate Social Responsibility (CSR)',
    desc: 'We transcend the traditional business philosophy of putting profit before all else, in order to meet our economic and moral responsibilities. Anu Flow Controls emphasizes its contributions to customers, employees, partners, the environment, and society, dedicating itself to:',
    points: ['Green Manufacturing', 'Green Research & Development (R&D)', 'Environmental Protection']
  }
];

function PurposeSustainabilitySection() {
  return (
    <section className="purpose-sustainability">
      <div className="sust-container">
        <div className="sust-header">
          <h3 className="sust-title">Purpose & Sustainability Commitment</h3>
          <div className="sust-divider"></div>
          <p className="sust-subtitle">Building a sustainable future through innovation, responsibility, and purpose-driven excellence.</p>
        </div>
        <div className="sust-grid">
          {sustainabilityContent.map((item, idx) => (
            <div className="sust-card" key={item.title} style={{ animationDelay: `${idx * 150}ms` }}>
              <div className="sust-icon-wrapper">
                {item.icon}
              </div>
              <div className="sust-content">
                <h4 className="sust-card-title">{item.title}</h4>
                <p className="sust-card-desc">{item.desc}</p>
                {item.points && (
                  <ul className="sust-points">
                    {item.points.map((point, i) => (
                      <li key={i} className="sust-point-item">
                        <span className="sust-point-marker"></span>
                        {point}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const AboutUs = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Header />
      <div className="aboutus-banner">
        <img
          src={banner}
          alt="About Us Banner"
          className="aboutus-banner__img"
        />
        <div className="aboutus-banner__overlay"></div>
        <div className="aboutus-banner__content">
          <h2 className="aboutus-banner__title">About Us</h2>
          <div className="aboutus-banner__subtitle">
            ANU Flow Control is a premier manufacturer of precision industrial valves, delivering engineered solutions and unmatched reliability across diverse sectors, worldwide.
          </div>
        </div>
      </div>
      <VerticalTimelineSection />
      <CoreValuesSection />
      <PurposeSustainabilitySection />
      <ValveShowcase />
      <VisionMission />
      <Footer />
      {scrollY > 300 && (
        <button 
          className="scroll-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          style={{
            position: 'fixed',
            bottom: '2rem',
            right: '2rem',
            background: '#dc2626',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: '50px',
            height: '50px',
            cursor: 'pointer',
            fontSize: '1.2rem',
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(220, 38, 38, 0.3)',
            transition: 'all 0.3s ease'
          }}
        >
          ↑
        </button>
      )}
    </>
  );
};

export default AboutUs;
